import React from 'react'
import HomeSubSection from '../WebSite/HomeSubSection/HomeSubSection';
import ProductionManagerImg from "../../images/gbrPN/PNImg5.webp";

export default function ABNNetworkOperator() {
  return (
    <div className='subSectionWrapper'>
          <h2 className=' container-title text-center mx-md-4'>AGRIBUSINESS NETWORK OPERATORS</h2>

    <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="agro-dealer-img"
          description="
          Agri Ecosystem Operators are companies (often startups or enterprise units) that design, build, own, and monetize multi-stakeholder agricultural networks around one or more interconnected use cases.
        
              "
          descriptionTitle="
          Agri Ecosystem Operators"
          src={ProductionManagerImg}
    
          // href4="http://abn.gbrapp.com/"
          // buttoncont1="Sign In"
        />

<HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="image2 "
          description=" Agri Impact Asset Developers are companies that mobilize sustainable investments and CSR funding from corporates and HNIs to build and manage eco-friendly agricultural assets. They design investable agri-assets focused on sustainability, biodiversity, and long-term value creation, and operate them through approved farm enterprises. By combining responsible land use, regenerative practices, and structured ecosystem participation, Agri Impact Asset Developers deliver reliable financial returns while advancing environmental impact and inclusive growth across all stakeholders.             "
          descriptionTitle="
          Agri Impact Asset Developers "
          
          // href4="http://abn.gbrapp.com/"
          // buttoncont1="Sign In"
        />

<HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="agro-dealer-img"
          description="
          Cluster-Based Business Organizations (CBBOs) are evolving into FPO Ecosystem Operators—platform-enabled companies that go beyond capacity building to actively build, operate, govern, and monetize networks of Farmer Producer Organizations (FPOs). By leveraging digital infrastructure and standardized workflows, they connect FPOs with inputs, advisory, markets, finance, and services, enabling scalable, multi-use-case agricultural ecosystems while driving both economic value and long-term sustainability.."
                    descriptionTitle="
          CBBO"
          src={ProductionManagerImg}
    
          // href4="http://abn.gbrapp.com/"
          // buttoncont1="Sign In"
        />
    </div>
  )
}
